export class Void {}